// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Notifications from '../../notifications/components/Notifications';
import { actions as AlertActions } from '../../../alert/duck';
import { actions as NotificationsActions } from '../../notifications/duck';
import { actions as EditProfileActions } from '../../edit-profile/duck';

import type { RootState } from '../../../index';
import { push } from 'react-router-redux';

function mapStateToProps(state: RootState) {
  const { notificationsSettings } = state.preferences.notifications;
  return {
    localValues: state.localValues,
    user: state.auth.user,
    hasCampaignMailNewsletter: !!notificationsSettings && notificationsSettings.hasCampaignMailNewsletter,
    hasMessageMailNewsletter: !!notificationsSettings && notificationsSettings.hasMessageMailNewsletter,
    hasMessageMailNotifications: !!notificationsSettings && notificationsSettings.hasMessageMailNotifications,
    hasMessagePushNotifications: !!notificationsSettings && notificationsSettings.hasMessagePushNotifications,
    hasMessageSmsNotifications: !!notificationsSettings && notificationsSettings.hasMessageSmsNotifications,
    hasOfferMailNewsletter: !!notificationsSettings && notificationsSettings.hasOfferMailNewsletter,
    hasOrderUpdateSmsNotifications: !!notificationsSettings && notificationsSettings.hasOrderUpdateSmsNotifications,
    isPutting: state.preferences.editProfile.isPutting,
    dataEditSuccessful: state.preferences.editProfile.dataEditSuccessful,
    putError: state.preferences.editProfile.putError,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...NotificationsActions, ...AlertActions, ...EditProfileActions,
    goToRedirect: (route) => push(route),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);



// WEBPACK FOOTER //
// ./src/modules/preferences/notifications/containers/NotificationsContainer.js